import { useEffect, useState } from "react";

import { Table as BootStrapTable } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import _ from "lodash";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

const Table = ({ columns, data, header = null }) => {
  const [tableData, setTableData] = useState([]);
  const [pagination, setPagination] = useState({
    pageCount: 0,
    page: 0,
  });
  const [filteredColumns, setFilteredColumns] = useState([]);
  const rowsPerPage = 10;

  useEffect(() => {
    setFilteredColumns(
      columns.filter((i) => !("condition" in i) || i.condition)
    );
  }, [columns]);

  useEffect(() => {
    setPagination((oldVal) => ({
      ...oldVal,
      pageCount: Math.ceil(data.length / rowsPerPage),
    }));
  }, [data]);

  useEffect(() => {
    setTableData(
      data.slice(
        pagination.page * rowsPerPage,
        pagination.page === 0
          ? rowsPerPage
          : (pagination.page + 1) * rowsPerPage
      )
    );
  }, [pagination.page, data]);

  const handleNext = () => {
    if (pagination.page + 1 < pagination.pageCount) {
      setPagination((oldVal) => ({ ...oldVal, page: oldVal.page + 1 }));
    }
  };

  const handlePrev = () => {
    if (pagination.page > 0) {
      setPagination((oldVal) => ({ ...oldVal, page: oldVal.page - 1 }));
    }
  };

  const handlePageClick = (pageNumber) => {
    setPagination((oldVal) => ({ ...oldVal, page: pageNumber }));
  };

  return (
    <Container>
      <Row>{header}</Row>
      <Row>
        <BootStrapTable striped bordered hover responsive>
          <thead>
            <tr>
              {filteredColumns.map((item) => (
                <th key={item?.key || item.label} className="table-heading">
                  {item?.hidden ? null : item.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((item) => {
              return (
                <tr key={item.id} className="table-text">
                  {filteredColumns.map((column) => {
                    let value =
                      column.type === "button"
                        ? item
                        : _.get(item, column.name);

                    if (column?.component) {
                      return (
                        <td
                          className={column?.classes}
                          style={{ textAlign: "center" }}
                          key={column.name}
                        >
                          {column.component(item)}
                        </td>
                      );
                    }

                    if (column?.convert) {
                      value = column.convert(value);
                    }
                    return <td key={`${value}-${column.name}`}>{value}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </BootStrapTable>
      </Row>
      {Math.ceil(data.length / rowsPerPage) > 1 && (
        <Row>
          <Pagination className="pagination-align">
            <Pagination.First
              disabled={
                [0, 1].includes(pagination.pageCount) || pagination.page === 0
              }
              onClick={() =>
                setPagination((oldVal) => ({ ...oldVal, page: 0 }))
              }
            />
            <Pagination.Prev
              disabled={
                [0, 1].includes(pagination.pageCount) || pagination.page === 0
              }
              onClick={handlePrev}
            />
            {[...Array(pagination.pageCount)].map((_, i) => (
              <Pagination.Item
                active={i === pagination.page}
                onClick={() => handlePageClick(i)}
                key={i}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              disabled={
                [0, 1].includes(pagination.pageCount) ||
                pagination.page === pagination.pageCount - 1
              }
              onClick={handleNext}
            />
            <Pagination.Last
              disabled={
                [0, 1].includes(pagination.pageCount) ||
                pagination.page === pagination.pageCount - 1
              }
              onClick={() =>
                setPagination((oldVal) => ({
                  ...oldVal,
                  page: pagination.pageCount - 1,
                }))
              }
            />
          </Pagination>
        </Row>
      )}
    </Container>
  );
};

export default Table;
